import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionTrigger,
} from '@radix-ui/react-accordion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import Container from '~/components/ui/Container';
import { cn } from '~/helpers/utils';
import { textContent, type FaqItem } from '~/pages/Tools/CalculateMaximumMortgage/Index/data';

const IndexFaqSection: React.FC = () => {
  const { faqItems } = textContent;
  
  return (
    <section className="bg-stone-50 py-14">
      <Container>
        <h2 className="font-display text-blue-600 font-bold text-center md:text-left text-xl md:text-3xl mb-8">Waar hangt jouw maximale hypotheek vanaf?</h2>

        <div>
          <Accordion
            className="space-y-2.5"
            type="multiple"
            defaultValue={['item-0']}
          >
            {faqItems.map(({ title, content }: FaqItem, index) => (
              <AccordionItem
                className={cn(
                  'p-4 bg-transparent rounded-lg',
                  'hover:bg-white/40',
                  'data-[state=open]:bg-white'
                )}
                value={`item-${index}`}
                key={title}
              >
                <AccordionHeader 
                  className={cn(
                    'flex items-center justify-between text-black',
                    'data-[state=open]:mb-3'
                  )}
                >
                  <AccordionTrigger 
                    className={cn(
                      'group flex items-center',
                      'text-lg md:text-xl font-display font-bold w-full text-left',
                    )}
                  >
                    {title}
                    <FontAwesomeIcon 
                      icon={faCirclePlus} 
                      className={cn(
                        'text-xl md:text-3xl ml-auto',
                        'group-data-[state=open]:rotate-45'
                      )} 
                    />
                  </AccordionTrigger>
                </AccordionHeader>
                <AccordionContent>
                  <div className="text-wrap whitespace-pre pr-10">
                    {content}
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </Container>
    </section>
  );
};

export default IndexFaqSection;